import {FormControl, FormLabel, MenuItem, Select, type SelectProps, Typography} from '@mui/material';
import {type ApplicationCreateDtoCategoryEnum, PassCategoryMapping} from "@/modules/exam-applications/shared";

type Props = {} & SelectProps<ApplicationCreateDtoCategoryEnum>

export function PassCategorySelect({ label, value, ...props }: Props) {
    return (
        <FormControl fullWidth>
            {label && (
                <FormLabel
                    sx={{
                        mb: 2
                    }}
                >
                    {label}
                </FormLabel>
            )}
            <Select
                displayEmpty
                renderValue={(value) => {
                    if (!value) {
                        return (
                            <Typography
                                sx={{
                                    color: theme => theme.palette.text.disabled
                                }}
                            >
                                Выберете категорию
                            </Typography>
                        );
                    }

                    return (
                        <>
                            {PassCategoryMapping?.[value as ApplicationCreateDtoCategoryEnum].text ?? 'Категория'}
                        </>
                    );
                }}
                value={value ?? ''}
                {...props}
            >
                {Object.entries(PassCategoryMapping).map(([key, value]) => {
                    return (
                        <MenuItem
                            value={key}
                            key={key}
                        >
                            {value.text}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
}
